module.exports = __webpack_public_path__ + "talk_to_parents-74c01eddc2d56f0107fe68a7b16e59d8.png";